module.exports = __webpack_public_path__ + "media/images/icons/icon-play-d24068ebe391ab4f45c503bda6aa332a.svg";